/**
 * @description 控制组件显示/隐藏
 * @author lizizhao
 */

/**
 * 控制组件显示/隐藏
 */
export default function visibleControl (eventData = {}) {
    // visible control

    if (!window.__XPUB__) {
        console.error('exposeApi is not defined!')
        return
    }

    const { refedIdMap } = eventData
    if (!refedIdMap) {
        // 兼容旧数据
        const { refedId, mode } = eventData
        if (!refedId || !mode) {
            console.error('未获取到事件参数', refedId, refedIdMap)
            return
        }
        refedIdMap[refedId] = {
            mode
        }
    }
    Object.keys(refedIdMap).forEach((refedId) => {
        const mode = refedIdMap[refedId].mode
        const elem = window.__XPUB__.getWidgetById(refedId)
        // 显示弹框组件
        switch (mode) {
        case 'visible':
            window.__XPUB__.setWidgetVisibility(refedId, true)
            break
        case 'hidden':
            window.__XPUB__.setWidgetVisibility(refedId, false)
            break
        case 'toggle':
            window.__XPUB__.setWidgetVisibility(refedId, !elem.editorStatus.show)
            break
        }
    })
}
